<template>
  <div>
    <div class="text-center mt-20" style="line-height: 200px">{{ tip }}</div>
    <!-- <div v-if="noAuth" style="text-align:center">
      <el-button plain type="primary" size="small" @click="expLogin()"
        >体验账户登录</el-button
      >
    </div>-->
  </div>
</template>
<script>
import store from '../../store/store'
import { wechatLogin, experienceLogin } from '../../service/getData'

export default {
  data() {
    return {
      tip: '登录中...',
      code: null,
      noAuth: false,
    }
  },
  created() {
    this.handleWechatLogin()
  },
  methods: {
    async handleWechatLogin() {
      let code = this.$route.query.code
      this.code = code
      if (code) {
        let res = await wechatLogin(code)
        if (res.code == 0 && res.data.id > 0) {
          res.data.loadRoute = false
          store.commit('login', res.data)
          if (store.state.loginRedirect) {
            this.$router.push(store.state.loginRedirect)
          } else {
            this.$router.push('/dashboard')
          }
        } else {
          this.$router.push({ path: '/check_mobile', query: { wxcode: code } })
        }
      } else {
        alert('信息获取失败，请重新进入')
        this.tip = '授权失败'
      }
    },
    async expLogin() {
      let res = await experienceLogin()
      if (res.code == 0) {
        res.data.loadRoute = false
        store.commit('login', res.data)
        if (res.data.default_pswd) {
          this.$router.push('/setpswd')
        } else {
          if (store.state.loginRedirect) {
            this.$router.push(store.state.loginRedirect)
          } else {
            this.$router.push('/dashboard')
          }
        }
      }
    },
  },
}
</script>